import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import * as i1 from 'ngx-bootstrap/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import * as i2 from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import * as i3 from '@angular/common';
import { NgIf } from '@angular/common';

class FontAwesomeComponent {
    constructor() {
        this.tooltipText = '';
        this.light = false;
        this.regular = false;
        this.solid = false;
        this.onClick = new EventEmitter();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FontAwesomeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: FontAwesomeComponent, isStandalone: false, selector: "yc-fa", inputs: { color: "color", icon: "icon", tooltipText: "tooltipText", popoverTemplate: "popoverTemplate", light: "light", regular: "regular", solid: "solid" }, outputs: { onClick: "onClick" }, ngImport: i0, template: `
    <ng-container *ngIf="popoverTemplate; else noPopover">
      <a href="javascript:void(0)"
         [popover]="popoverTemplate"
         [outsideClick]="true">
        <i class="{{ light ? 'fal' : regular ? 'far' : solid ? 'fas' : 'fa' }} fa-{{icon}}"
           [style.color]="color"
           [tooltip]="tooltipText">
        </i>
      </a>
    </ng-container>

    <ng-template #noPopover>
      <i class="{{ light ? 'fal' : regular ? 'far' : solid ? 'fas' : 'fa' }} fa-{{icon}}"
         [style.color]="color"
         [tooltip]="tooltipText"
         (click)="onClick.emit()">
      </i>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["adaptivePosition", "tooltip", "placement", "triggers", "container", "containerClass", "boundariesElement", "isOpen", "isDisabled", "delay", "tooltipHtml", "tooltipPlacement", "tooltipIsOpen", "tooltipEnable", "tooltipAppendToBody", "tooltipAnimation", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "tooltipFadeDuration", "tooltipTrigger"], outputs: ["tooltipChange", "onShown", "onHidden", "tooltipStateChanged"], exportAs: ["bs-tooltip"] }, { kind: "directive", type: i2.PopoverDirective, selector: "[popover]", inputs: ["adaptivePosition", "boundariesElement", "popover", "popoverContext", "popoverTitle", "placement", "outsideClick", "triggers", "container", "containerClass", "isOpen", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FontAwesomeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'yc-fa',
                    template: `
    <ng-container *ngIf="popoverTemplate; else noPopover">
      <a href="javascript:void(0)"
         [popover]="popoverTemplate"
         [outsideClick]="true">
        <i class="{{ light ? 'fal' : regular ? 'far' : solid ? 'fas' : 'fa' }} fa-{{icon}}"
           [style.color]="color"
           [tooltip]="tooltipText">
        </i>
      </a>
    </ng-container>

    <ng-template #noPopover>
      <i class="{{ light ? 'fal' : regular ? 'far' : solid ? 'fas' : 'fa' }} fa-{{icon}}"
         [style.color]="color"
         [tooltip]="tooltipText"
         (click)="onClick.emit()">
      </i>
    </ng-template>
  `,
                    standalone: false
                }]
        }], propDecorators: { color: [{
                type: Input
            }], icon: [{
                type: Input
            }], tooltipText: [{
                type: Input
            }], popoverTemplate: [{
                type: Input
            }], light: [{
                type: Input
            }], regular: [{
                type: Input
            }], solid: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });

class IconsModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: IconsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: IconsModule, declarations: [FontAwesomeComponent], imports: [i1.TooltipModule, i2.PopoverModule, NgIf], exports: [FontAwesomeComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: IconsModule, imports: [TooltipModule.forRoot(),
            PopoverModule.forRoot()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: IconsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TooltipModule.forRoot(),
                        PopoverModule.forRoot(),
                        NgIf
                    ],
                    declarations: [
                        FontAwesomeComponent
                    ],
                    exports: [
                        FontAwesomeComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FontAwesomeComponent, IconsModule };
